import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ListItem from '../index';
import { regExpFindUnderscore } from '../../../../../constants/regExps';
import { defaultUserPhoto } from '../../../../../constants/ui';
import Rating from '../../../ui/Rating';
import Delete from '../../../../common/forms/buttons/Delete';
import UsersService from '../../../../../services/UsersService';

export default class ListItemWorker extends Component {
  _formatStatus = text => text.replace(regExpFindUnderscore, ' ');

  removeWorker = (e, workerId) => {
    e.stopPropagation();
    this.props.removeWorkerClick(workerId);
  };

  render () {
    const { worker, isOnboarded, removeWorkerClick, notEditable } = this.props;
    const canRemoveWorker = removeWorkerClick && !notEditable;

    return (
      <ListItem link={UsersService.isAdmin() ? `workers/${worker.user_id || worker.id}` : null}>
        <div className={`col d-flex align-items-center col-sm-6 col-lg-3`}>
          <div style={{ backgroundImage: `url('${worker.photo_image_url || defaultUserPhoto}')` }} className='avatar-sm' />
          <div className='font-weight-bold'>
            <div className='text-ellipsis'>{worker.first_name} {worker.last_name}</div>

            {worker.average_rating && isOnboarded && (
              <div className='mt-1'>
                <Rating value={worker.average_rating} disabled buttonClassName='btn-rate-sm' />
              </div>
            )}
          </div>
        </div>
        <div className={`col col-sm-6 col-lg-3`}>
          <div className='text-ellipsis'>{worker.email}</div>
          <div>{worker.phone}</div>
        </div>
        <div className='col col-sm-6 col-lg-2'>
          <div className='text-ellipsis'>{worker.city}</div>
          <div>{worker.state} {worker.zip}</div>
        </div>
        {!isOnboarded ? (
          <Fragment>
            <div className='col col-sm-6 col-lg-2'>
              <div className='text-capitalize'>{this._formatStatus(worker.background_status || 'Not specified')}</div>
              <div className='list-item-label'>Background Status</div>
            </div>
            <div className='col col-sm-6 col-lg-2'>
              <div className='text-capitalize'>{this._formatStatus(worker.onboarding_status || 'Not specified')}</div>
              <div className='list-item-label'>Onboarding Status</div>
            </div>
          </Fragment>
        ) : worker.skills ? (
          <div className={`col ${canRemoveWorker ? 'col-sm-5 col-lg-3' : 'col-sm-6 col-lg-4'} d-flex flex-wrap`}>
            {worker.skills.map(skill => (
              <div className='skill-icon has-tooltip' style={{ backgroundImage: `url('${skill.icon_url}')` }} key={skill.id}>
                <div className='ui-tooltip text-md'>
                  {skill.reference_title}
                </div>
              </div>
            ))}
          </div>
        ) : null}
        { canRemoveWorker && (
          <div className='col col-1 pl-0 pl-md-3 text-md-right'>
            <Delete onClick={e => this.removeWorker(e, worker.id)} />
          </div>
        )}
      </ListItem>
    );
  }
}

ListItemWorker.propTypes = {
  worker: PropTypes.object.isRequired,
  isOnboarded: PropTypes.bool,
  notEditable: PropTypes.bool,
  removeWorkerClick: PropTypes.func
};

ListItemWorker.defaultProps = {
  isOnboarded: true
};



// WEBPACK FOOTER //
// ./src/components/common/lists/ListItem/ListItemWorker/index.js